import './all-res.css';

export function ExpresenceSubPage() {

    return (
        <div className="container-fluid m-4">
            <h4 className="gradient-text"> User Experience </h4>
            <p className='para'>Provide an intuitive, user-friendly experience for visitors, including easy navigation and clear information architecture.</p>
        </div>
    )
}